//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'
export default {
  components: {
    Button,
  },
  props: {
    actionLabel: {
      type: String,
      default: 'Añadir',
    },
  },
  methods: {
    handleClick() {
      this.$emit('action-click')
    },
  },
}
